const providerCancellationTokens = ['cancel', 'cancelled', 'canceled', 'abort', 'aborted', 'access_denied'];

export default function isProviderCancellationCallback(search) {
  const queryParams = new URLSearchParams(search);

  return Array.from(queryParams.entries()).some(([key, value]) => {
    const normalizedKey = key.toLowerCase();
    const normalizedValue = String(value).toLowerCase();

    if (providerCancellationTokens.some((token) => normalizedKey.includes(token))) {
      return normalizedValue !== 'false';
    }

    return ['error', 'error_description', 'status', 'reason'].includes(normalizedKey)
      && providerCancellationTokens.some((token) => normalizedValue.includes(token));
  });
}
